// frontend/src/components/common/BlurOverlay.jsx
import React from 'react';

const BlurOverlay = ({ children, isAuthenticated, onLoginClick }) => {
  if (isAuthenticated) {
    return children;
  }

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Blurred content */}
      <div
        style={{
          flex: 1,
          filter: 'blur(6px)',
          pointerEvents: 'none',
          userSelect: 'none',
          overflow: 'auto',
        }}
      >
        {children}
      </div>
      {/* Overlay with message and links */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'var(--overlay)',
          zIndex: 50,
          padding: 20,
          textAlign: 'center',
        }}
      >
        <div style={{ color: 'var(--text-on-overlay)', fontSize: 18, fontWeight: 600, marginBottom: 12 }}>
          Login to unlock this panel
        </div>
        <div style={{ color: 'var(--text-on-overlay-muted)', fontSize: 14 }}>
          <button
            onClick={() => onLoginClick('login')}
            style={{
              background: 'none',
              border: 'none',
              color: 'var(--accent-hover)',
              textDecoration: 'underline',
              cursor: 'pointer',
              fontSize: 14,
            }}
          >
            Login
          </button>
          {' or '}
          <button
            onClick={() => onLoginClick('register')}
            style={{
              background: 'none',
              border: 'none',
              color: 'var(--accent-hover)',
              textDecoration: 'underline',
              cursor: 'pointer',
              fontSize: 14,
            }}
          >
            Register
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlurOverlay;